module.exports = __webpack_public_path__ + "static/media/Illus-SummerLate@3x.b9de60ba.png";